import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/authStore';
import { landingPath } from '@/features/dashboard/config';

/**
 * Admin layout — requires a valid auth token AND role=admin.
 * Non-admin users are bounced to their landing report.
 */
export function AdminLayout() {
  const auth = useAuth();
  const location = useLocation();
  if (!auth?.token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (auth.role !== 'admin') {
    return <Navigate to={landingPath(auth.allowedReports, false)} replace />;
  }
  return <Outlet />;
}
